import { LayoutCanvas } from '../../types/types';
import { LAYOUT_FIXED_CANVAS_PADDING } from '../../constants';
import { getLayoutFixedCellSize } from './getLayoutFixedCellSize';

export type LayoutFixedCell = {
  x: number;
  y: number;
  width: number;
  height: number;
};

// Fixed mode: the items fill a regular grid purely by their array index. The
// canvas values only shape the buttons — cell size gridX × gridY, gaps
// gapX/gapY. The grid dimensions come from the configured `columns` (fills row
// by row) or `rows` (fills column by column); degrades to a single column when
// neither is set. Per-item geometry is not used.
export const getLayoutFixedCell = (
  canvas: LayoutCanvas,
  index: number
): LayoutFixedCell => {
  const { width: cellWidth, height: cellHeight } =
    getLayoutFixedCellSize(canvas);
  const gapX = canvas.gapX ?? 0;
  const gapY = canvas.gapY ?? 0;
  const hasColumns = !!canvas.columns && canvas.columns > 0;
  const hasRows = !!canvas.rows && canvas.rows > 0;

  if (hasRows && !hasColumns) {
    const rowCount = canvas.rows as number;

    return {
      x:
        LAYOUT_FIXED_CANVAS_PADDING +
        Math.floor(index / rowCount) * (cellWidth + gapX),
      y: LAYOUT_FIXED_CANVAS_PADDING + (index % rowCount) * (cellHeight + gapY),
      width: cellWidth,
      height: cellHeight,
    };
  }

  const columnCount = hasColumns ? (canvas.columns as number) : 1;

  return {
    x: LAYOUT_FIXED_CANVAS_PADDING + (index % columnCount) * (cellWidth + gapX),
    y:
      LAYOUT_FIXED_CANVAS_PADDING +
      Math.floor(index / columnCount) * (cellHeight + gapY),
    width: cellWidth,
    height: cellHeight,
  };
};
